import React, { useMemo } from "react";
import {
  SessionCardsGrid,
  SectionHeaderTitle,
  SectionTitleTypography,
  StepTypography,
  SessionSelectionContainer,
} from "./SessionSelection.styles";
import { SessionCard, MeshColours, Checkbox } from "..";
import { Sessions } from "../../models/Session";
import { usePriorityAllocationStore } from "src/store/usePriorityAllocationStore";

export interface CustomSessionSelectionProps {
  showName?: string | null;
  showMinimumAge?: number | null;
  sessions?: Sessions | null;
  onSessionCardClickHandler: Function;
  selectedSessionId: number | undefined;
}


export const colorArray: MeshColours[] = [
  "pink-purple-green",
  "pink-blue-teal",
  "orange-pink",
  "blue-green-teal",
  "teal-green",
  "red-green-teal",
];


export const priorityColorArray: MeshColours[] = [
  "light-gold",
  "strong-gold",
 ];


export const SessionSelection = ({
  showName = null,
  sessions = null,
  onSessionCardClickHandler,
  showMinimumAge,
  selectedSessionId,
  ...rest
}: CustomSessionSelectionProps) => {
  const priorityAllocFullSessions = usePriorityAllocationStore(
    (state) => state.priorityAllocFullSessions
  );

  const hasPriorityContext = Object.keys(priorityAllocFullSessions).length > 0;
  const getIsPriorityForSessionFull = (sessionId: number) => priorityAllocFullSessions[sessionId]?.isFull ?? true;

  const sessionsWithPriority = useMemo(() => {
    return sessions?.map((session) => ({
      ...session,
      isPriorityActive: !getIsPriorityForSessionFull(Number(session.id)),
      isPriorityFull: hasPriorityContext && getIsPriorityForSessionFull(Number(session.id)),
    }));
  }, [sessions, getIsPriorityForSessionFull, hasPriorityContext]);

  return (
    <SessionSelectionContainer>
      <SectionHeaderTitle id="session-selection">
        <StepTypography>Step 1:</StepTypography>
        <SectionTitleTypography>Select a Session</SectionTitleTypography>
      </SectionHeaderTitle>

      <SessionCardsGrid>
        {sessions === null ? (
          <StepTypography>Loading...</StepTypography>
        ) : sessions && sessions.length === 0 ? (
          <StepTypography data-cy="no-session-found">No sessions found</StepTypography>
        ) : (
          <>
            {sessionsWithPriority?.map((session, index) => {
              return (
                <SessionCard
                  key={session.id}
                  showName={showName}
                  showMinimumAge={showMinimumAge}
                  session={session}
                  handleClick={() => onSessionCardClickHandler(session)}
                  selectedSessionId={selectedSessionId}
                  colour={session.isPriorityActive ? priorityColorArray[index % priorityColorArray.length] : colorArray[index % colorArray.length]}
                  isPriority={session.isPriorityActive}
                  isPriorityFull={session.isPriorityFull}
                />
              )})}
          </>
        )}
      </SessionCardsGrid>
    </SessionSelectionContainer>
  );
};

export interface SessionSelectionProps
  extends React.ComponentProps<typeof SessionSelection> {
  as?: React.ElementType;
}

SessionSelection.displayName = "SessionSelection";
